
const rangeMixins = {
    methods:{
        videoSteps(steps){
            console.log('steps',steps);
            try{
              if(this.controller && !this.controller.player.paused()){
                this.controller.player.pause();
              }
            }catch(e){console.log(e)}
            this.playerSteps = steps;
        },

        hhmmssToMs(s){
          var hms = s;   // your input string
          let reg = new RegExp(':');
          if(!reg.test(s)) return Number(s);
          var a = hms.split(':'); // split it at the colons
          var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
          return seconds;
       },

       playMarkinMarkout(playinfo, playOnEachClick=false){
         console.log('>>>>>>>>>>',playinfo,playOnEachClick);
         let start = playinfo.markers.start , end = playinfo.markers.end;
         let reg = new RegExp(':');
         if(reg.test(playinfo.markers.start)){
          start = this.hhmmssToMs(playinfo.markers.start) * 1000;
          end = this.hhmmssToMs(playinfo.markers.end) * 1000;
         }
          this.markinMarkoutPlayerListernerController.setMarkers(start,end);
          this.markinMarkoutPlayerListernerController.preview.call(this,playOnEachClick);
          return {start:start,end:end};
        },

        setMarkinMarkoutPlayerListener(controller){
           this.markinMarkoutPlayerListernerController = controller;
        },

        captureCanvas(thumbnailBas64){
          this.markinMarkoutPlayerListernerController.postAssetData(thumbnailBas64);
        },

       setPlayerDuration(playerDur){

         this.playerDuration = playerDur;
       }
   },
   data(){
    return {
       playerSteps:[],
       playerObj:{},
       playerDuration:null,
       markinMarkoutPlayerListernerController:{},
       markinMarkoutThumbnailObj:{show:false,url:'',filename:'',dur:'00-00',videoRef:null,frames:{},thumbnail:'',capture:true}
     }
   },

   mounted(){
      this.$root.$on('player-duration', this.setPlayerDuration);
   },
   beforeDestroy(){
     this.$root.$off('player-duration', this.setPlayerDuration);
   }
};

export default rangeMixins;